import PostIcon from '../../../icons/post.svg'

export const POST_SEARCH_ITEM_ICON = { Icon: PostIcon }
